import './header';
import './footer';
import './newsletter';

new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#footer',
  methods: {
    cartPreview() {
      function updateCartPreview(items) {
        let cartPreview = document.querySelector('.cart-preview');
        if (cartPreview) {
          let itensCartPreview = document.querySelector('.items_cart_preview');
          itensCartPreview.innerHTML = '';

          items.forEach((item) => {
            let formattedPrice = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.unit_price);
            let variations = item.variation_value ? `<p class="cart-item-content-size">Tamanho: <b>${item.variation_value}</b></p>` : '';

            let itemHTML = `
            <li class="cart-item">
              <figure>
                <img src="${item.image_medium}" alt="${item.name}">
              </figure>
              <div class="cart-item-content">
                <div class="cart-item-content-item">
                  <h4 class="cart-item-content-name">${item.name}</h4>
                  <p class="cart-item-content-price">${formattedPrice}</p>
                </div>
                <div class="cart-item-content-item">
                  ${variations}
                  <p class="cart-item-content-qtd">Quantidade: <b>${item.quantity}</b></p>
                </div>
              </div>
            </li>
            `;

            itensCartPreview.innerHTML += itemHTML;
          });

          // Adiciona o event listener para os botões de deletar
          document.querySelectorAll('.delete-item-button').forEach(button => {
            button.addEventListener('click', function () {
              let itemId = this.getAttribute('data-original-id');
              deleteCartItem(itemId);
            });
          });
        }
      }

      $.ajax({
        type: 'GET',
        url: '/api/front/cart/items/?version=2',
        headers: { 'Content-Type': 'application/json' },
        dataType: 'json'
      }).done(function (data) {
        if (data && data.cart_data && data.cart_data.items) {
          updateCartPreview(data.cart_data.items);
        }
      });

      $(document).on("ajaxComplete", function (event, xhr, settings) {
        if (settings.url.includes('/api/front/cart/items/') && settings.type === 'POST') {
          let valid_status = [200, 201];
          if (valid_status.includes(xhr.status)) {
            const responseJson = xhr.responseJSON.cart_data.items;
            updateCartPreview(responseJson);
          }
        }
      });
    },
  },
  mounted() {
    this.cartPreview();
  }
});

/* Fix bug with slick on new product render (vitrine) */
const elementosLazy = document.querySelectorAll('.lazy-img');

elementosLazy.forEach(elemento => {
  const dataSrc = elemento.getAttribute('data-src');
  if (dataSrc) {
    elemento.setAttribute('src', dataSrc);
    elemento.removeAttribute('data-src');
  }
});

// Cart has a delay and this code here fix it
setTimeout(() => {
  if (document.body.id === 'cart') {
    const elementosLazy = document.querySelectorAll('.lazy-img');

    elementosLazy.forEach(elemento => {
      const dataSrc = elemento.getAttribute('data-src');
      if (dataSrc) {
        elemento.setAttribute('src', dataSrc);
        elemento.removeAttribute('data-src');
      }
    });
  }
}, 5000);

/* Header Padding fix */
var page404Element = document.querySelector('.page-404');

if (page404Element) {
  page404Element.style.paddingTop = '133px';
  page404Element.style.setProperty('padding-top', '133px', 'important');
}

/* Name hover translate effect */
const figcaptionElements = document.querySelectorAll('.product-item__content--figcaption-name');

figcaptionElements.forEach((figcaption) => {
  const anchor = figcaption.querySelector('a');
  if (anchor) {
    const figcaptionWidth = figcaption.offsetWidth;
    const anchorWidth = anchor.offsetWidth;

    const transitionDuration = Math.max(1, Math.abs(anchorWidth - figcaptionWidth) / 100);

    if (anchorWidth > figcaptionWidth) {
      anchor.style.transition = `all ${transitionDuration}s linear`;
      figcaption.classList.add('action');
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {

  const containerShoppub = document.querySelector('#dynamic-page-extra .main-content .container-shoppub');
  if (containerShoppub) {
    const physicalStore = document.querySelector('#dynamic-page-extra .physical-store');
    if (physicalStore) {
      containerShoppub.classList.add('page-front');
    }
  }

  waitForElementToExist('.rotation-vitrine').then(element => {
    if (element) {
      let rotationNames = element.querySelectorAll('.vitrines-select .vitrines-select-name');
      let initVitrine = element.querySelectorAll('.vitrines-products .vitrines-products-item');
      initVitrine = Array.from(initVitrine);

      if (rotationNames.length && initVitrine.length) {
        initVitrine[0].classList.add('active');
        rotationNames[0].classList.add('active');

        function activeTab(index) {
          initVitrine.forEach((content) => {
            content.classList.remove('active');
          });
          rotationNames.forEach((content) => {
            content.classList.remove('active');
          });
          initVitrine[index].classList.add('active');
          rotationNames[index].classList.add('active');

          // Atualizar classe no contêiner .count
          $('.count').attr('class', function (i, c) {
            return c.replace(/(^|\s)count-\S+/g, '');
          }).addClass(`count-${index + 1}`);

        }

        rotationNames.forEach((itemMenu, index) => {
          itemMenu.addEventListener('click', (e) => {
            e.preventDefault();
            activeTab(index);
          }, { passive: true });
        });

        // Initial update for the first active tab
        activeTab(0);
      }
    }
  });

  function loadSvg() {
    const svgs = document.querySelectorAll("[class^='no-svg-']");

    svgs.forEach(function (svg) {
      var oldClasses = svg.getAttribute("class");
      var newClasses = oldClasses.replace(/no-svg-/g, '');
      svg.setAttribute("class", newClasses);
    });
  }

  function onFirstScroll() {
    loadSvg();
    window.removeEventListener('scroll', onFirstScroll);
  }

  window.addEventListener('scroll', onFirstScroll, { passive: true });

  var elements = document.querySelectorAll('.product-campaigns-tags__campaign');

  Array.from(elements).forEach(function (tag) {
    if (tag.textContent.includes("Black") || tag.textContent.includes("BLACK") || tag.textContent.includes("black")) {
      tag.classList.add("black");
    }
  });


  (function ($) {
    $.fn.visible = function (partial) {

      var $t = $(this),
        $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top,
        _bottom = _top + $t.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;

      return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };

  })(jQuery);

  function loadWidgets(event) {

    $(".product-item:not(.widget-loaded)").each(function (i, el) {
      var el = $(el);
      if (el.visible(true)) {
        el.addClass("widget-loaded");
        $(el).children().trigger("mouseenter");
      } else {
        //el.removeClass("visible");
      }
    });
  }

  $(window).scroll(loadWidgets);
  setTimeout(loadWidgets, 0);

});